const DELIMITERS = [',', ';', '\t', '|'];

// BOM detection + UTF-8 validation fallback
function detectEncoding(buffer) {
	const bytes = new Uint8Array(buffer);
	if (bytes[0] === 0xEF && bytes[1] === 0xBB && bytes[2] === 0xBF) return 'utf-8-sig';
	if (bytes[0] === 0xFF && bytes[1] === 0xFE) return 'utf-16-le';
	if (bytes[0] === 0xFE && bytes[1] === 0xFF) return 'utf-16-be';

	try {
		new TextDecoder('utf-8', { fatal: true }).decode(buffer);
		return 'utf-8';
	} catch {
		return 'windows-1252';
	}
}

function decodeBuffer(buffer, encoding) {
	const label = encoding === 'utf-8-sig' ? 'utf-8'
		: encoding === 'utf-16-le' ? 'utf-16le'
			: encoding === 'utf-16-be' ? 'utf-16be'
				: encoding;
	return new TextDecoder(label).decode(buffer);
}

function detectDelimiter(headerLine) {
	let best = ',';
	let maxCount = 0;
	for (const d of DELIMITERS) {
		const count = (headerLine.match(new RegExp(d === '|' ? '\\|' : d, 'g')) || []).length;
		if (count > maxCount) {
			maxCount = count;
			best = d;
		}
	}
	return best;
}

function parseCsvLine(line, delimiter = ',') {
	const fields = [];
	let current = '';
	let inQuotes = false;
	for (let i = 0; i < line.length; i++) {
		const ch = line[i];
		if (inQuotes) {
			if (ch === '"' && line[i + 1] === '"') {
				current += '"';
				i++;
			} else if (ch === '"') {
				inQuotes = false;
			} else {
				current += ch;
			}
		} else if (ch === '"') {
			inQuotes = true;
		} else if (ch === delimiter) {
			fields.push(current.trim());
			current = '';
		} else {
			current += ch;
		}
	}
	fields.push(current.trim());
	return fields;
}

export function parseCsvFile(rawFile) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = (e) => {
			const encoding = detectEncoding(e.target.result);
			const text = decodeBuffer(e.target.result, encoding);
			const lines = text.split(/\r?\n/).filter(l => l.trim());
			if (lines.length === 0) {
				resolve({ header: [], results: [], encoding, delimiter: ',' });
				return;
			}
			const delimiter = detectDelimiter(lines[0]);
			const header = parseCsvLine(lines[0], delimiter);
			const results = lines.slice(1).map(line => {
				const values = parseCsvLine(line, delimiter);
				const obj = {};
				header.forEach((h, i) => { obj[h] = values[i] ?? ''; });
				return obj;
			});
			resolve({ header, results, encoding, delimiter });
		};
		reader.onerror = () => reject(new Error('READ_FAILED'));
		reader.readAsArrayBuffer(rawFile);
	});
}
